import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cp-member-home',
  templateUrl: './cp-member-home.component.html',
  styleUrls: ['./cp-member-home.component.scss'],
})
export class CpMemberHomeComponent implements OnInit {
  noNomineeAdded = false;
  constructor(private router: Router) {}

  ngOnInit() {}

  navigateToClaims(){
    this.router.navigate(['cp-member/claims']);
  }

  redirectToManageProfile(){
    this.router.navigate(['/cp-member/manage-profile']);

  }

  showAddNomineeBaner(event){
    this.noNomineeAdded = event;
  }

  redirectToContactUs(){
    this.router.navigate(['/cp-member/contact']);
  }

}
